<studio-button-legacy
  class="dropdown-select-button"
  [matMenuTriggerFor]="matMenuSelect"
  (menuOpened)="menuOpened()"
  (menuClosed)="menuClosed()"
  [theme]="buttonTheme"
  [attr.data-selected]="selectedOption | get : displayKey"
  [iconSize]="iconSize"
  [iconLeft]="iconPosition === 'left' ? iconName : null"
  [iconRight]="iconPosition === 'right' ? iconName : null"
  [iconDirection]="iconDirection"
>
  <span data-test="dropdown-label">{{ (selectedOption | get : displayLabel) || placeHolder }}</span>
</studio-button-legacy>

<mat-menu class="studio-dropdown" #matMenuSelect>
  <ng-container *ngFor="let option of options">
    <div
      class="studio-dropdown-select"
      [attr.data-option]="option | get : displayKey"
      [class.studio-dropdown-active]="option | isActive : selectedOption : displayKey"
      (click)="optionSelect(option)"
    >
      <p class="studio-dropdown-option-label">
        <b>{{ option | get : displayLabel }}</b>
      </p>
      <ng-container *ngIf="option | get : displayDescription as description">
        <p class="studio-dropdown-description">
          {{ description }}
        </p>
      </ng-container>
    </div>
  </ng-container>
</mat-menu>
